var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "main-menu menu-bg-blue-transparent",
      class: _vm.showFeatureButtons ? "border-top-right-radius-none" : "",
    },
    [
      _c("MMP_UserProfile", {
        attrs: {
          id: "userProfile",
          release_date: _vm.release_date,
          showFeatureButtons: _vm.showFeatureButtons,
          user: _vm.user,
          version: _vm.version,
        },
        on: {
          getFeatureButtons: function ($event) {
            return _vm.$emit("getFeatureButtons", $event)
          },
        },
      }),
      _vm._v(" "),
      _vm.homeScreenComponents && _vm.mapLayers != null
        ? _c("MMP_TabNav", {
            attrs: {
              id: "tabnav",
              btnClass: _vm.btnClass,
              customerLayersButtonsCtrl: _vm.customerLayersButtonsCtrl,
              customerProjectId: _vm.customerProjectId,
              cust_layersObj: _vm.cust_layersObj,
              dprVisible: _vm.dprVisible,
              homeScreenComponents: _vm.homeScreenComponents,
              isAdmin: _vm.isAdmin,
              isUshrUser: _vm.isUshrUser,
              layersListMaxHeight: _vm.layersListMaxHeight,
              map: _vm.map,
              mmp_layersObj: _vm.mmp_layersObj,
              projects: _vm.projects,
              spinnerManager: _vm.spinnerManager,
              subNavVisible: _vm.subNavVisible,
              ushrLayersButtonsCtrl: _vm.ushrLayersButtonsCtrl,
              ushrLayersVisible: _vm.ushrLayersVisible,
              user: _vm.user,
              zoomEnded: _vm.zoomEnded,
              zoomLevelCap: _vm.zoomLevelCap,
              showLidarPanel: _vm.showLidarPanel,
              baseMapsOpen: _vm.baseMapsOpen,
              extentsOpen: _vm.extentsOpen,
            },
            on: {
              clearCurrentPositionsInterval: function ($event) {
                return _vm.$emit("clearCurrentPositionsInterval")
              },
              getCustomerCoverageLayers: function ($event) {
                return _vm.$emit("getCustomerCoverageLayers")
              },
              initAdminConsole: function ($event) {
                return _vm.$emit("initAdminConsole")
              },
              initEntryManager: function ($event) {
                return _vm.$emit("initEntryManager")
              },
              initGTPModal: function ($event) {
                return _vm.$emit("initGTPModal")
              },
              initHDTAdminConsole: function ($event) {
                return _vm.$emit("initHDTAdminConsole")
              },
              initReportConsole: function ($event) {
                return _vm.$emit("initReportConsole")
              },
              layerButtonsChanged: function ($event) {
                return _vm.$emit("layerButtonsChanged", $event)
              },
              loadProject: function ($event) {
                return _vm.$emit("loadProject", $event)
              },
              mainMenuSizeChange: function ($event) {
                return _vm.$emit("mainMenuSizeChange")
              },
              onResize: function ($event) {
                return _vm.$emit("onResize")
              },
              showCustomerLayer: function ($event) {
                return _vm.$emit("showCustomerLayer", $event)
              },
              toggleLayerVisibility: function ($event) {
                return _vm.$emit("toggleLayerVisibility", $event)
              },
              toTopOfList: function ($event) {
                return _vm.$emit("toTopOfList", $event)
              },
              updateZoomEnded: function ($event) {
                return _vm.$emit("updateZoomEnded", $event)
              },
              initImageCarousel: function ($event) {
                return _vm.$emit("initImageCarousel")
              },
              initEODFieldReviewCarousel: function ($event) {
                return _vm.$emit("initEODFieldReviewCarousel")
              },
              initGTPReportModal: function ($event) {
                return _vm.$emit("initGTPReportModal")
              },
              initWmsModal: function ($event) {
                return _vm.$emit("initWmsModal")
              },
              initAnalytics: function ($event) {
                return _vm.$emit("initAnalytics")
              },
              initWCL: function ($event) {
                return _vm.$emit("initWCL")
              },
              initDataTool: function ($event) {
                return _vm.$emit("initDataTool")
              },
              initSI: function ($event) {
                return _vm.$emit("initSI")
              },
              initSales: function ($event) {
                return _vm.$emit("initSales")
              },
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }